const BASE_URL = process.env.REACT_APP_URL_API;
export const URL_API = BASE_URL;
